export default __webpack_public_path__ + "685e5573bb03580aebd560b1841683f6.png";